import { render, staticRenderFns } from "./index_view.vue?vue&type=template&id=2a9c75e3&scoped=true&"
import script from "./index_view.vue?vue&type=script&lang=js&"
export * from "./index_view.vue?vue&type=script&lang=js&"
import style0 from "./index_view.vue?vue&type=style&index=0&id=2a9c75e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9c75e3",
  null
  
)

export default component.exports